import icon from "../../assets/lightning.svg";
import type { Property } from "../../types";

export const poeOutput: Property = {
  id: "poeOutput",
  title: "poeOutput.title",
  icon,
};
